"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _settings = require("../settings");
var _rulesActions = require("./rulesActions");
var _ajaxStatusActions = require("./ajaxStatusActions");
var _actionTypes = require("./actionTypes");
var getVisualizerImageUrl = function getVisualizerImageUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    choiceId = _ref.choiceId,
    optionId = _ref.optionId,
    choiceValue = _ref.choiceValue;
  return function (dispatch, getState) {
    var settings = (0, _settings.getSettings)();
    var _getState = getState(),
      configurator = _getState.configurator;
    var current = (0, _rulesActions.getSelections)(configurator.choices, configurator.options);
    var payload = {
      SiteId: settings.siteId,
      ProductId: configurator.productInfo.productId,
      OptionDetails: current
    };
    if (typeof settings.visualizationApi === 'string') {
      dispatch((0, _ajaxStatusActions.beginAjaxCall)());
      return (0, _axios["default"])({
        url: "".concat(settings.visualizationApi),
        crossDomain: true,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: payload
      }).then(function (data) {
        dispatch({
          type: _actionTypes.GET_VISUALIZER_IMAGE_URL_SUCCESS,
          payload: data
        });
        return data;
      })["catch"](function (err) {
        return console.log(err);
      }); // eslint-disable-line no-console
    } else if (typeof settings.visualizationApi === 'function') {
      return settings.visualizationApi(payload, dispatch, {
        choiceId: choiceId,
        optionId: optionId,
        choiceValue: choiceValue
      });
    }
    return Promise.resolve({
      status: 200
    });
  };
};
var _default = exports["default"] = getVisualizerImageUrl;
//# sourceMappingURL=getVisualizerImageUrl.js.map